/** Türkçe Excel için noktalı virgül ayırıcılı CSV (UTF-8 BOM). */

function escapeCsvCell(value: string | number | null | undefined): string {
  const raw = value == null ? '' : String(value);
  if (/[";\n\r]/.test(raw)) {
    return `"${raw.replace(/"/g, '""')}"`;
  }
  return raw;
}

export function downloadCsvAsExcel(
  filenameBase: string,
  headers: string[],
  rows: Array<Array<string | number | null | undefined>>
): void {
  const sep = ';';
  const lines = [
    headers.map(escapeCsvCell).join(sep),
    ...rows.map((row) => row.map(escapeCsvCell).join(sep)),
  ];
  const bom = '\uFEFF';
  const blob = new Blob([bom + lines.join('\r\n')], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  const stamp = new Date().toISOString().slice(0, 10);
  link.href = url;
  link.download = `${filenameBase}_${stamp}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
